// extracted by mini-css-extract-plugin
export var breadcrumbs = "Breadcrumbs-module--breadcrumbs--bddff";
export var separator = "Breadcrumbs-module--separator--dd86a";